export const RULE_TEST_RESPONSE_DEFAULT = {
  json: '',
  executionTime: '',
};
